<template>
  <div class="top_search">
    <div class="search">
      <!-- <div>
        <span class="searchText" v-for="(item, index) in fun" :key="item.id" @click="itemClick(index)" :class="{is_select: isSelect(index)}">{{item.name}}</span>
      </div>
      <label style="display: flex" :for="fun[i].name">
        <input type="text" class="searchInput" :placeholder="fun[i].ahead" v-model="fun[i].value" @keyup.enter="inputSearch(i)" autocomplete="new-password">
        <button class="input_btn_my" @click="inputSearch(i)">搜&nbsp;&nbsp;索</button>
      </label> -->
    </div>
  </div>
</template>

<script>

  export default {
    name: "topSearch",
    data(){
      return{
        fun: [
          {
            id: 1,
            name: '美亚',
            path: 'https://www.amazon.com/s/ref=nb_sb_noss_1?field-keywords=',
            ahead: '适用于美国亚马逊搜索',
            value: ''
          },
          {
            id: 2,
            name: '加亚',
            path: 'https://www.amazon.ca/s?k=',
            ahead: '适用于加拿大亚马逊搜索',
            value: ''
          },
          {
            id: 3,
            name: '英亚',
            path: 'https://www.amazon.co.uk/s/ref=nb_sb_noss_1?field-keywords=',
            ahead: '适用于英国亚马逊搜索',
            value: ''
          },
          {
            id: 4,
            name: '法亚',
            path: 'https://www.amazon.fr/s?k=',
            ahead: '适用于法国亚马逊搜索',
            value: ''
          },
          {
            id: 5,
            name: '德亚',
            path: 'https://www.amazon.de/s?k=',
            ahead: '适用于德国亚马逊搜索',
            value: ''
          },
          {
            id: 6,
            name: '日亚',
            path: 'https://www.amazon.co.jp/s/ref=nb_sb_noss_1?field-keywords=',
            ahead: '适用于日本亚马逊搜索',
            value: ''
          },
          {
            id: 7,
            name: '意亚',
            path: 'https://www.amazon.it/s?k=',
            ahead: '适用于意大利亚马逊搜索',
            value: ''
          },
          {
            id: 8,
            name: '西亚',
            path: 'https://www.amazon.es/s?k=',
            ahead: '适用于西班牙亚马逊搜索',
            value: ''
          },
          {
            id: 9,
            name: '澳亚',
            path: 'https://www.amazon.com.au/s?k=',
            ahead: '适用于澳洲亚马逊搜索',
            value: ''
          },
          {
            id: 10,
            name: '百度',
            path: 'https://www.baidu.com/s?tn=94725333_hao_pg&wd=',
            ahead: '请输入搜索内容',
            value: ''
          },
          {
            id: 11,
            name: 'Google',
            path: 'https://www.google.com.hk/search?q=',
            ahead: 'Google 一下',
            value: ''
          },
          {
            id: 12,
            name: 'Bing',
            path: 'https://www.bing.com/search?q=',
            ahead: 'BingGo',
            value: ''
          }
        ],
        i: 0,
      }
    },
    methods: {
      itemClick(index){
        this.i = index;
      },
      isSelect(index){
        return this.i === index;
      },
      inputSearch(i){
        if(this.fun[i].value !== ''){
          window.open(this.fun[i].path + this.fun[i].value);
        }else {
          alert('请输入搜索内容')
        }

      }
    }
  }
</script>

<style scoped>
  .top_search{
    display: flex;
    height: 100%;
  }

  .search{
    align-self: center;
    height: 115px;
  }

  .searchText{
    color: white;
    /* color: gray; */
  }

  .searchText:hover{
    opacity: .9;
    cursor: pointer;
  }

  .is_select{
    color: #04a7f4;
  }

  .searchInput{
    border: 2px solid #00a2e8;
    outline: none;
  }

  .input_btn_my{
    background-color: #00a2e8;
    border: none;
    outline: none;
    color: white;
    font-weight: bold;
    margin-left: -1px;
  }

  .input_btn_my:hover{
    opacity: .8;
    cursor: pointer;
  }

  .searchInput::-webkit-input-placeholder { 
      /* WebKit browsers */ 
      color: rgb(163, 163, 163); 
    } 
    .searchInput:-moz-placeholder { 
      /* Mozilla Firefox 4 to 18 */ 
      color: rgb(163, 163, 163);
    } 
    .searchInput::-moz-placeholder { 
      /* Mozilla Firefox 19+ */ 
      color: rgb(163, 163, 163);
    } 
    .searchInput:-ms-input-placeholder { 
      /* Internet Explorer 10+ */ 
      color: rgb(163, 163, 163);
    }

  @media screen and (max-width: 1600px) {
    .top_search{
      padding: 1.8rem 0 1.8rem 0;
      
    }

    .search{
      width: 50rem;
    }

    .searchText{
      margin: 0.8rem;
      font-size: 1.2rem;
      padding: 0 0 0.4rem 0;
    }
    .searchInput{
      min-width: 50rem;
      height: 2.8rem;
      padding: 1rem 1.8rem;
      margin: 0.2rem 0 0 0;
      font-size: 1.2rem;
    }

    .input_btn_my{
      min-width: 7rem;
      height: 2.8rem;
      margin-top: 0.2rem;
    }
  }

  @media screen and (min-width: 1600px){
    .top_search{
      padding: 40px 0 40px 0;
    }

    .search{
      width: 700px;
    }

    .searchText{
      margin: 10px;
      font-size: 14px;
      padding: 0 0 5px 0;
    }

    .searchInput{
      min-width: 600px;
      height: 35px;
      padding: 16px 20px;
      margin: 2px 0 0 0;
      font-size: 14px;
    }

    .input_btn_my{
      min-width: 80px;
      font-size: 15px;
      height: 35px;
      margin-top: 2px;
    }
  }
</style>
